import cn from "classnames";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useEffect, useState, memo } from "react";

import { useGetSet } from "@api/hooks/queries/useGetSet";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { getPageFolderName } from "@config/cms";
import { blurDataURL } from "@config/config";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";

import { typeSlider } from "./datas";
import s from "./GaleryV1Block.module.scss";

const GaleryV1Block = ({ settings, data, updateField, className }) => {
  const { t } = useTranslation(["common"]);
  const { title, collections } = data;
  const { items } = collections[typeSlider];

  const { blockType } = settings.common;

  const [allSlides, setAllSlides] = useState([]);

  const [getSet] = useGetSet({ lazy: true });

  useEffect(() => {
    const promises = [];
    const filtered = items.filter((item) => {
      return typeof item.isShow === "boolean" ? item.isShow : true;
    });
    filtered.forEach((slide) => {
      if (slide.setId) {
        promises.push(
          getSet({
            variables: {
              id: slide.setId,
            },
          }),
        );
      }
    });

    Promise.all(promises).then((data) => {
      setAllSlides([]);
      let counter = 0;
      filtered.forEach((item) => {
        if (item.setId) {
          const setPages = data[counter].data.getSet.data.map((page) => {
            return {
              title: page.title,
              alt: page.seo.description,
              image: page.seo.thumbnailBig || page.seo.thumbnail,
              link: `/${getPageFolderName()[item.setType]}/${page.slug}`,
            };
          });

          setAllSlides((slides) => [...slides, ...setPages]);

          counter += 1;

          return;
        }

        setAllSlides((items) => [...items, item]);
      });
    });
  }, [items]);

  return (
    <Container className={cn(s.galeryV1, className)}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            // autoScroll
            startPadding
            className={s.slider}
            slidesCount={allSlides.length}
            collectionType={typeSlider}
            render={(sliderProps) => (
              <>
                <SliderSlides {...sliderProps} className={s.slides}>
                  {allSlides.map((slide, key) => {
                    const { link, title, image, alt } = slide;
                    return (
                      <Link href={link} key={key} className={s.slide}>
                        <div className={s.image}>
                          <Image
                            className={s.img}
                            src={image}
                            fill
                            style={{
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                            alt={alt}
                            blurDataURL={blurDataURL}
                            quality={100}
                          />
                        </div>
                        <div className={s.directions}>{title}</div>
                        <div className={s.tickets}>{t("check tickets")}</div>
                      </Link>
                    );
                  })}
                </SliderSlides>
                <SliderControls className={s.controls} {...sliderProps} />
              </>
            )}
          />
        </section>
      </Container>
    </Container>
  );
};

export default memo(GaleryV1Block);
